import { Injectable } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  ErrorMessage,
  Errors,
  ResetPasswordErrorMessages,
  ResetPasswordFormAttributes,
  ResetPasswordPageContent
} from '@com-delta-idp/mnx-login-ui';
import { LoginHelperUtils } from '../../../utils/login-helper.utils';
import {
  FirstNameValidator,
  LastNameValidator,
  UsernameSkyMilesNumberEmailValidator
} from '../../../validator/validator';
import { RESET_PASSWORD_INLINE_ERROR_MESSAGE } from '../../constants/login-constant';
import { LoginModalContent } from '../../models/aem';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordHelperService {
  resetPasswordForm!: UntypedFormGroup;

  constructor(protected loginHelperUtils: LoginHelperUtils) {}

  createForm(): UntypedFormGroup {
    this.resetPasswordForm = new UntypedFormGroup({
      userId: new UntypedFormControl(null, [
        Validators.required,
        UsernameSkyMilesNumberEmailValidator
      ]),
      firstName: new UntypedFormControl(null, [
        Validators.required,
        FirstNameValidator
      ]),
      lastName: new UntypedFormControl(null, [
        Validators.required,
        LastNameValidator
      ])
    });
    return this.resetPasswordForm;
  }

  getFormGroup(): UntypedFormGroup {
    return this.resetPasswordForm;
  }

  getPageContent(aemResponse: LoginModalContent): ResetPasswordPageContent {
    const { resetPassword, pageHeader, loginCredentials } = aemResponse;

    return {
      ...resetPassword,
      pageHeader: {
        ...pageHeader,
        headerTitle: resetPassword.headerTitle,
        headerSubTitle: resetPassword.headerSubTitle
      },
      footer: loginCredentials.footer,
      buttonLabel: resetPassword.nextDisplayView.button_modal,
      errors: this.getInitialErrorMessage(aemResponse.errors)
    };
  }

  getFormControlName(control: string): string | void | undefined {
    for (const key of Object.keys(this.getFormGroup().controls)) {
      if (key === control) return key;
    }
  }

  getErrorMessageSkymilesNo(errors: Errors): string {
    let errorMessages = '';
    errors.errorMessages.forEach((option: ErrorMessage) => {
      if (option['errorId'] === 'resetPasswordSkymilesNo') {
        errorMessages = option['errorMessageDescription'];
      }
    });
    return (
      errorMessages || `Skymiles Number ${RESET_PASSWORD_INLINE_ERROR_MESSAGE}`
    );
  }

  getInitialErrorMessage(errors: Errors): ResetPasswordErrorMessages {
    let userIdErrorMessages = '',
      firstNameErrorMessages = '',
      lastNameErrorMessages = '',
      alertWarningErrorMessages = '';
    errors.errorMessages.forEach((option: ErrorMessage) => {
      if (option['errorId'] === 'resetPasswordUserId') {
        userIdErrorMessages = option['errorMessageDescription'];
      }
      if (option['errorId'] === 'resetPasswordFirstName') {
        firstNameErrorMessages = option['errorMessageDescription'];
      }
      if (option['errorId'] === 'resetPasswordLastName') {
        lastNameErrorMessages = option['errorMessageDescription'];
      }
      alertWarningErrorMessages = 'To continue, please correct the';
    });
    return {
      userIdErrorMessage: userIdErrorMessages,
      firstNameErrorMessage: firstNameErrorMessages,
      lastNameErrorMessage: lastNameErrorMessages,
      alertWarning: alertWarningErrorMessages
    };
  }

  getFormAttributes(): ResetPasswordFormAttributes {
    return {
      errorCount: 0,
      submitAttempt: false,
      errorAlertBanner: false,
      userIdControlTouched: false,
      firstNameControlTouched: false,
      lastNameControlTouched: false,
      isEmail: false,
      isMfa: false,
      disableActionButton: false
    };
  }
}
